export default "__VITE_ASSET__EfX3OKKe__"